/*
 * Public API Surface of misc
 */

export * from './ngkit-theme.provider';
export * from './ngkit-theme';
